var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinanceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2408_19392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5577 18H1.79396C0.80489 18 0 17.0929 0 15.9779V2.02209C0 0.907146 0.80489 0 1.79396 0H12.5577C13.5468 0 14.3517 0.907146 14.3517 2.02209V15.9779C14.3517 17.0929 13.5468 18 12.5577 18ZM1.79396 1.19597C1.46985 1.19597 1.19597 1.5742 1.19597 2.02209V15.9779C1.19597 16.4258 1.46985 16.804 1.79396 16.804H12.5577C12.8818 16.804 13.1557 16.4258 13.1557 15.9779V2.02209C13.1557 1.5742 12.8818 1.19597 12.5577 1.19597H1.79396Z",
    fill: "#2060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0328 5.81547H3.3185C2.60836 5.81547 2.67546 5.38379 2.67546 4.09807C2.67546 3.56547 2.60836 3.13379 3.3185 3.13379H11.0328C11.7429 3.13379 11.6755 3.56547 11.6755 4.09807C11.6755 5.38379 11.7429 5.81547 11.0328 5.81547Z",
    fill: "#2060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18614 8.42638H2.99017C2.594 8.42638 2.27258 8.10496 2.27258 7.7088C2.27258 7.31263 2.594 6.99121 2.99017 6.99121H4.18614C4.58231 6.99121 4.90372 7.31263 4.90372 7.7088C4.90372 8.10496 4.58231 8.42638 4.18614 8.42638Z",
    fill: "#2060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77397 8.42638H6.578C6.18183 8.42638 5.86041 8.10496 5.86041 7.7088C5.86041 7.31263 6.18183 6.99121 6.578 6.99121H7.77397C8.17014 6.99121 8.49155 7.31263 8.49155 7.7088C8.49155 8.10496 8.17014 8.42638 7.77397 8.42638Z",
    fill: "#2060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3618 8.42638H10.1658C9.76966 8.42638 9.44824 8.10496 9.44824 7.7088C9.44824 7.31263 9.76966 6.99121 10.1658 6.99121H11.3618C11.758 6.99121 12.0794 7.31263 12.0794 7.7088C12.0794 8.10496 11.758 8.42638 11.3618 8.42638Z",
    fill: "#2060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77397 11.6407H6.578C6.18183 11.6407 5.86041 11.3193 5.86041 10.9232C5.86041 10.527 6.18183 10.2056 6.578 10.2056H7.77397C8.17014 10.2056 8.49155 10.527 8.49155 10.9232C8.49155 11.3193 8.17014 11.6407 7.77397 11.6407Z",
    fill: "#2060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3618 11.6407H10.1658C9.76966 11.6407 9.44824 11.3193 9.44824 10.9232C9.44824 10.527 9.76966 10.2056 10.1658 10.2056H11.3618C11.758 10.2056 12.0794 10.527 12.0794 10.9232C12.0794 11.3193 11.758 11.6407 11.3618 11.6407Z",
    fill: "#2060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3619 14.8546H6.578C6.18183 14.8546 5.86041 14.5332 5.86041 14.137C5.86041 13.7409 6.18183 13.4194 6.578 13.4194H11.3619C11.7581 13.4194 12.0795 13.7409 12.0795 14.137C12.0795 14.5332 11.7581 14.8546 11.3619 14.8546Z",
    fill: "#2060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18614 11.6407H2.99017C2.594 11.6407 2.27258 11.3193 2.27258 10.9232C2.27258 10.527 2.594 10.2056 2.99017 10.2056H4.18614C4.58231 10.2056 4.90372 10.527 4.90372 10.9232C4.90372 11.3193 4.58231 11.6407 4.18614 11.6407Z",
    fill: "#2060EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18614 14.8546H2.99017C2.594 14.8546 2.27258 14.5332 2.27258 14.137C2.27258 13.7409 2.594 13.4194 2.99017 13.4194H4.18614C4.58231 13.4194 4.90372 13.7409 4.90372 14.137C4.90372 14.5332 4.58231 14.8546 4.18614 14.8546Z",
    fill: "#2060EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2408_19392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.3517,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceIcon);
export default __webpack_public_path__ + "static/media/FinanceIcon.185f716e7dc0c9cc697d46032bb07905.svg";
export { ForwardRef as ReactComponent };